export const NAME = 'register';

// User Registration constants
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const SUCCESS_REGISTER = 'SUCCESS_REGISTER';
export const FAILURE_REGISTER = 'FAILURE_REGISTER';



// WEBPACK FOOTER //
// ./src/services/authentication/register/constants.js